import { render } from "./AssistantWidget.vue?vue&type=template&id=3bb08810&scoped=true"
import script from "./AssistantWidget.vue?vue&type=script&lang=js"
export * from "./AssistantWidget.vue?vue&type=script&lang=js"

import "./AssistantWidget.vue?vue&type=style&index=0&id=3bb08810&lang=css"
import "./AssistantWidget.vue?vue&type=style&index=1&id=3bb08810&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb08810"]])

export default __exports__